import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { SwitchAccount as ActAsIcon } from '@mui/icons-material';
import { getActAs, stopActAs, actAsMinutesLeft } from '../utils/actAs';

/**
 * The persistent band a White Knight owner sees while acting as a partner company.
 * It is on every page, counts down the 30 minutes, and "Stop" returns them to their own
 * company (Owner Console → Partner companies).
 */
export default function ActAsBanner() {
  const [actAs, setActAs] = useState(() => getActAs());
  const [minutes, setMinutes] = useState(() => actAsMinutesLeft());

  useEffect(() => {
    const tick = () => {
      const a = getActAs();
      setActAs(a);
      setMinutes(actAsMinutesLeft());
      if (!a && actAs) window.location.href = '/owner'; // ran out while on the page
    };
    const id = setInterval(tick, 30 * 1000);
    window.addEventListener('storage', tick);
    return () => { clearInterval(id); window.removeEventListener('storage', tick); };
  }, [actAs]);

  if (!actAs) return null;
  const stop = () => {
    stopActAs();
    window.location.href = '/owner';
  };
  return (
    <Box sx={{ position: 'sticky', top: 0, zIndex: (t) => t.zIndex.drawer + 2, bgcolor: '#6b4e00', color: '#fff', px: 2, py: 0.75, display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
      <ActAsIcon fontSize="small" />
      <Typography variant="body2" sx={{ flex: 1, minWidth: 240 }}>
        Acting as <b>{actAs.organization?.name}</b> ({actAs.organization?.slug}). You see and change that company's data as yourself. Live updates and your own profile stay White Knight's. Ends in {minutes} min.
      </Typography>
      <Button size="small" variant="outlined" color="inherit" onClick={stop}>Stop</Button>
    </Box>
  );
}
